import INavBar from '@src/component/INavBar'
import VerticalSpace from '@src/component/VerticalSpace'
import { formatString } from '@src/constant'
import { replaceTo } from '@src/route'
import CommonService from '@src/service/commonService'
import {getUrlParams, isEmpty} from '@src/util'
import { List } from 'antd-mobile'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import './index.scss'

interface DetailProps {
  registerprovince?: string
  registercity?: string
  firstpaidpercent?: number
  stage?: number
  [key: string]: any
}

function PlanDetail(props: any) {
  const {
    location: { search },
  } = props
  const params = getUrlParams(search)
  const [detail, setDetail] = useState<DetailProps>({})
  //   const [config, setConfig] = useState<any>({})

  useEffect(() => {
    CommonService.getPlanDetail({ loaningInfoId: params.id }).then(
      (res: any) => {
        res.mortgageserviceamount = 0
        if(params.source === 'cfmoto') {
          res.commissionrate = 0.03
        }
        if(params.source === 'cfmoto' && params.experiment === '1') {
          res.mortgageserviceamount = 300
        }
        setDetail(res || {})
      }
    )
  }, [])

  //   useEffect(() => {
  //     CommonService.getConfig().then((res: any) => {
  //       setConfig(JSON.parse(res))
  //     })
  //   }, [])

  const toEdit = () => {
    if (['1', '3'].includes(params.status)) {
      replaceTo('/plan-detail-edit', {
        userName: params.userName,
        id: params.id,
        status: params.status,
        source: params.source,
        rate: detail.rate,
        earnestmoneypercent: detail.earnestmoneypercent,
        firstpaidpercent: detail.firstpaidpercent,
        experiment: params.experiment,
        price:detail.netPrice,
        stage: detail.stage
      })
    }
  }

  return (
    <div className="detail-page">
      <INavBar title={`${params.userName}的方案详情`} />
      {detail.rejectReason && (
        <div className="reason">
          <span>
            {params.status === '1' && '驳回'}
            {params.status === '3' && '拒绝'}
            {params.status === '6' && '终止'}
            {params.status === '7' && '结束'}原因：
          </span>
          {detail.rejectReason}
        </div>
      )}
      <VerticalSpace size={20}>
        <div className="part">
          <div className="part-title">车辆信息</div>
          <List>
            <List.Item extra={detail.brandname}>品牌：</List.Item>
            <List.Item extra={detail.vehiclename}>车型：</List.Item>
            {/* <List.Item extra={detail.productat?moment(detail.productat).format(formatString):''}>
              出厂日期：
            </List.Item>
            <List.Item
              extra={detail.firstregisterat?moment(detail.firstregisterat).format(formatString):''}
            >
              首次上牌日期：
            </List.Item>
            <List.Item extra={detail.platenumber||''}>车牌号：</List.Item>
            <List.Item extra={detail.vin}>车架号：</List.Item>
            <List.Item extra={detail.enginenumber||''}>发动机号：</List.Item>
            <List.Item
              extra={`${detail.registerprovince || ''}-${
                detail.registercity || ''
              }`}
            >
              上牌城市：
            </List.Item> */}
            <List.Item extra={detail.caramount}>车辆价格（元）：</List.Item>
          </List>
        </div>
        <div className="part">
          <div className="part-title">金融方案选择</div>
          <List>
            <List.Item extra={`${(detail.rate * 100).toFixed(2)}%`}>费率（%）：</List.Item>
            <List.Item extra={`${(detail.earnestmoneypercent * 100).toFixed(2)}%`}>
              履约保证金比例（%）：
            </List.Item>
            <List.Item extra={`${((detail.firstpaidpercent || 0) * 100).toFixed(2)}%`}>
              首付比例（%）：
            </List.Item>
            <List.Item extra={`${detail.stage || 6}期`}>租赁期数：</List.Item>
            <List.Item extra={`${((detail.commissionrate || 0) * 100).toFixed(2)}%`}>
              手续费率（%）：
            </List.Item>
            {/* <List.Item extra={detail.containtax === 1 ? '是' : '否'}>
              是否分期购置税：
            </List.Item> */}
            {detail.containtax === 1 && (
              <List.Item extra={detail.taxamount}>购置税金额（元）：</List.Item>
            )}

            <List.Item
              extra={detail.containsecurityservice === 1 ? '是' : '否'}
            >
              是否分期盗抢权益：
            </List.Item>
            {/* <List.Item
              extra={
                detail.purchasepersonalaccidentinsurance === 1 ? '是' : '否'
              }
            >
              是否购买人身意外险：
            </List.Item>
            <List.Item
              extra={detail.containrideaccidentservice === 1 ? '是' : '否'}
            >
              是否购买骑行意外险：
            </List.Item>
            <List.Item extra={detail.mortgageserviceamount}>抵押代办费（元）：</List.Item>
            <List.Item extra={detail.paidamount}>已付款金额（元）：</List.Item> */}
          </List>
        </div>
        <div className="part">
          <div className="part-title">方案展示（具体以还款计划表为准。）</div>
          <List>
            <List.Item extra={detail.finalamount}>融租总额（元）：</List.Item>
            <List.Item extra={detail.firstpaidamount}>首付款（元）：</List.Item>
            <List.Item extra={detail.everypayamount}>月还款（元）：</List.Item>
            {/* <List.Item extra={detail.everypayamount}>月还款（元）：</List.Item> */}
            {detail.mortgageserviceamount>0&&<List.Item extra={detail.mortgageserviceamount}>
              抵押代办费：
            </List.Item>}
            <List.Item extra={detail.securityserviceamount}>
              盗抢保障费用（元）：
            </List.Item>
            <List.Item extra={detail.commission}>手续费（元）：</List.Item>
            <List.Item extra={detail.performanceBond}>履约保证金（元）：</List.Item>
            {/* <List.Item extra={detail.personalaccidentserviceamount}>
              人身意外险费用（元）：
            </List.Item> */}
            
            {/* 宗申贴息 */}
            {!isEmpty(detail.freeStage) && <List.Item extra={detail.freeStage}>减免费用期数 ：</List.Item>}
            {!isEmpty(detail.freeCount) && <List.Item extra={detail.freeCount}>减免费用合计（元）：</List.Item>}
            {!isEmpty(detail.rentCount) && <List.Item extra={detail.rentCount}>减免后租金合计（元）：</List.Item>}
            {/* <List.Item extra={detail.mortgageserviceamount}>抵押代办费（元）：</List.Item> */}
          </List>
        </div>
      </VerticalSpace>
      {['1', '2', '3', '4'].includes(params.status) && (
        <div className="btn" onClick={toEdit}>
          {params.status === '1' && '审核驳回，请重新编辑下发用户确认'}
          {params.status === '2' && '用户待确认'}
          {params.status === '3' && '用户已拒绝，重新编辑'}
          {params.status === '4' && '用户已确认，待后台审核'}
        </div>
      )}
    </div>
  )
}

export default PlanDetail
